import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import useDebounce$1 from '../../cinnamon-core/es/components/utility/useDebounce.js';

/**
 * Provides state handling for controlling whether a picker is open
 * replaces the default 'click away' handling with 'blur' to avoid portal event propagation issues
 */

var usePickerOpenState = function usePickerOpenState() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var debouncedOpen = useDebounce$1(function () {
    return setOpen(true);
  }, 100);
  var debouncedClose = useDebounce$1(function () {
    return setOpen(false);
  }, 200);
  return {
    open: open,
    onOpen: function onOpen() {
      debouncedOpen();
    },
    onClose: function onClose() {
      debouncedOpen.cancel();
      debouncedClose.cancel();
      setOpen(false);
    },
    popperProps: {
      onBlur: function onBlur() {
        debouncedClose();
      },
      onFocus: function onFocus() {
        debouncedClose.cancel();
      }
    }
  };
};

var usePickerOpenState$1 = usePickerOpenState;

export { usePickerOpenState$1 as default };
